<template>
  <div class="home">
    <div id="drag">
      <div class="Yuan" @click="testShowBtn">
        <span></span>
        <span></span>
      </div>
      <div class="Yuan-title">
        <div
          style="height: 20px; width: 100%; cursor: all-scroll"
          class="YuanTitleDrag"
        ></div>
        <div class="zTreeDiv">
          <ul id="WorkPlaneTree" class="ztree"></ul>
        </div>
      </div>
    </div>
    <div id="MyViewerDiv"></div>
    <!-- <button onclick="snaphot();" style="position:absolute;"></button> -->
    <!-- @*视点选择框*@ -->
    <div id="lll">
      <div
        id="div_viewpoint"
        class="m-right-sidebar"
        style="
          position: absolute;
          display: none;
          top: 20px;
          right: 30px;
          transition: none;
        "
      >
        <h2
          class="sdbcName"
          style="font-size: 20px; font-weight: 300; cursor: all-scroll"
        >
          视点保存
        </h2>
        <div
          class="btnClose close_bt_p"
          onclick="bimViewPointNew.hiddenViewPoint();"
          style="color: #000000; font-weight: 300; margin: 8px 3px 0 0"
        >
          ×
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <div class="navBox">
          <!-- <ul id="nav" class="nav" name="nav" style="display: block;">
            <li>
              <b style="border-radius: 15px 0 0 15px;">基本</b>
            </li>
            <li>
              <b>碰撞</b>
            </li>
            <li>
              <b>协作</b>
            </li>
          </ul>-->
          <div id="search_viewpoint" class="search">
            <b class="imgsearch"></b>
            <button
              id="vp-imgsearch"
              style="position: absolute; left: 0"
              class="btnSearch"
              onclick="bimViewPointNew.filterNodes()"
            >
              <img
                width="20px"
                style="position: relative; left: 4px"
                src="../../../assets/img/搜索 (2).png"
              />
            </button>
            <input
              type="text"
              id="vp-searchtxt"
              value="请输入搜索内容..."
              onfocus="if(value=='请输入搜索内容...')  {value=''}"
              onblur="if (value=='') {value='请输入搜索内容...'}"
              onkeypress="bimViewPointNew.viewpoint_keydown(event)"
              name="name"
              style="padding-left: 20px"
            />
            <b
              class="clo1"
              id="vp-close"
              style="
                font-weight: 300;
                position: absolute;
                right: 0;
                color: #c3c3c3;
                font-size: 16px;
              "
              onclick="bimViewPointNew.closeShow()"
              >×</b
            >
          </div>
        </div>
        <div class="body_viewpoint">
          <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <button
          class="btn btn-info viewpoint_btn btn_fas"
          style="display: none"
          id="vp-btn-deletebatch"
          data-placement="bottom"
          data-toggle="tooltip"
          title="删除"
          onclick="bimViewPointNew.deleteViewPoints()"
        >
          删除
        </button>
        <el-button
          type="primary"
          id="vp-btn-mark"
          data-placement="bottom"
          data-toggle="tooltip"
          title="涂鸦"
          size="small"
          style="margin: 0 0 0 66px; display: inline-block"
          onclick="bimViewPointNew.showMarkTool()"
          >涂鸦</el-button
        >
        <el-button
          type="primary"
          id="vp-btn-save"
          data-placement="bottom"
          data-toggle="tooltip"
          size="small"
          title="保存"
          onclick="bimViewPointNew.onSaveLayer()"
          style="display: inline-block"
          >保存</el-button
        >
        <button
          size="small"
          type="primary"
          class="btn btn-info"
          id="vp-btn-share"
          title="分享"
          style="display: none"
          data-placement="bottom"
          data-toggle="tooltip"
          onclick="shareStructureQR.viewpointQr()"
        >
          分享
        </button>
        <button
          class="btn btn-info viewpoint_btn btn_fastn"
          style="display: none"
          id="vp-btn-startclash"
          data-placement="bottom"
          data-toggle="tooltip"
          title="发起碰撞"
          onclick="workflowCollision.main('','','-1')"
        >
          发起碰撞
        </button>
        <div
          id="rMenu_viewpoint"
          class="rMenu"
          style="top: 123px; visibility: hidden"
        >
          <ul id="rShowMenu_viewpoint">
            <li
              id="vp_m_add"
              onclick="bimViewPointNew.addTreeNode()"
              style="display: list-item"
            >
              新建视点目录
            </li>
            <li
              id="vp_m_del"
              onclick="bimViewPointNew.removeTreeNode()"
              style="display: list-item"
            >
              删除
            </li>
            <li
              id="vp_m_ren"
              onclick="bimViewPointNew.renameTreeNode()"
              style="display: list-item"
            >
              重命名
            </li>
            <!-- <li
              id="vp_m_faq"
              onclick="bimViewPointNew.createFlow()"
              style="display: list-item;"
            >发起流程</li>-->
            <!-- @*
            <li
              id="vp_m_updateMark"
              onclick="bimViewPointNew.updateMark()"
              style="display: none;"
            >更新涂鸦</li>*@-->
          </ul>
        </div>
      </div>
    </div>
    <div id="box_gray" class="gray"></div>
    <!-- @*过滤器*@ -->
    <div class="filter_box" id="gg" style="cursor: default; display: none">
      <div class="box_title">过滤器</div>
      <div class="btnClose" onclick="bimOriginFilter.hideDoc()">×</div>

      <div class="box_content">
        <div class="tab_title">
          <ul id="tabs" class="clearfix">
            <li class="current" onclick="boxselect(this)">
              <a href="#" title="过滤器">过滤器</a>
            </li>
            <li onclick="boxselect(this)">
              <a href="#" title="框选集">框选集</a>
            </li>
          </ul>
        </div>
        <!-- <ul id="treeDemo" class="ztree content_particulars"></ul> -->
        <div class id="menu_content_box">
          <div id="tab1" class="menu_table" style="display: block">
            <div class="farther" id="list">
              <div class="body_origin_filter">
                <ul id="treeDemo_origin_filter" class="ztree scroll_bar"></ul>
              </div>
              <div
                id="rMenu_origin_filter"
                class="rMenu"
                style="top: 253px; left: 257px; visibility: hidden"
              >
                <ul id="rShowMenu_origin_filter">
                  <li
                    id="origin_f_add"
                    onclick="bimOriginFilter.xx()"
                    style="display: none"
                  >
                    增加
                  </li>
                  <li
                    id="origin_f_del"
                    onclick="bimOriginFilter.yy()"
                    style="display: none"
                  >
                    删除
                  </li>
                  <li
                    id="origin_f_ren"
                    onclick="bimOriginFilter.zz()"
                    style="display: none"
                  >
                    重命名
                  </li>
                </ul>
              </div>
            </div>
            <div class="footr_box">
              <div class="box_options" style="display: none">
                <div class="clearfix">
                  <input
                    class="fl"
                    type="button"
                    onclick="bimOriginFilter.contreChoose()"
                    value="反选"
                  />
                  <input
                    class="fl daochu"
                    type="button"
                    onclick="filterExecute.modelshowEXCELvalue()"
                    id="daochu_btn"
                    value="导出工程量"
                    style="display: none"
                  />
                  <input
                    class="fr top_img"
                    type="button"
                    id="advanced_btn"
                    value="高级选项"
                  />
                </div>
                <div class="sidebar_advanced" style="display: none">
                  <div class="screen_box">
                    <p>
                      <span>参数:</span>
                      <select id="canshu" class="select"></select>
                    </p>
                    <p>
                      <span>条件:</span>
                      <select id="tiaojian" class="select">
                        <option value>请选择筛选条件</option>
                      </select>
                    </p>
                    <p>
                      <span>值:</span>
                      <input value id="chooseValue" />
                    </p>
                  </div>
                </div>
              </div>

              <div class="box_btn_op">
                <div class="clearfix">
                  <!-- @*
                    <input
                      class="fl"
                      type="button"
                      value="确定"
                      onclick="filterExecute.attribute_select()"
                  />*@-->
                  <input
                    class="fr ml_20"
                    type="button"
                    onclick="bimOriginFilter.attribute_save()"
                    value="收藏"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="tab2" class="menu_table" style="display: none">
            <div class="farther" id="list">
              <div class="body_originOther_filter">
                <ul
                  id="treeDemo_originOther_filter"
                  class="ztree scroll_bar"
                ></ul>
              </div>
              <div
                id="rMenu_originOther_filter"
                class="rMenu"
                style="visibility: hidden"
              >
                <ul id="rShowMenu_originOther_filter">
                  <li
                    id="originOther_f_addPlanDir"
                    onclick="bimOriginFilter.addPlanDir()"
                  >
                    新建目录
                  </li>
                  <li
                    id="originOther_f_delPlan"
                    onclick="bimOriginFilter.removePlan()"
                  >
                    删除
                  </li>
                  <li
                    id="originOther_f_renPlan"
                    onclick="bimOriginFilter.renamePlan()"
                  >
                    重命名
                  </li>
                  <!-- <li id="originOther_f_faq" onclick="bimOriginFilter.createFlow()">发起流程</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--添加标签 -->
    <div class="AddLable">
      <input type="hidden" id="mobl10" />
      <input type="hidden" id="mobl11" />
      <input type="hidden" id="mobl12" />
      <div>
        <label class="labelName">名称：</label>
        <input id="lableName" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">地点：</label>
        <input id="lableAddr" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">拍摄时间：</label>
        <input id="lableTime" type="text" placeholder="yyyy-MM-dd" />
      </div>
      <br />
      <div>
        <label>类型：</label>
        <dl class="labelType">
          <!-- <dd>
            <input type="radio" name="lableType" checked value="1" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>
          <dd>
            <input type="radio" name="lableType" value="2" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>-->
        </dl>
      </div>
      <br />
      <div class="isQJ" style="display: none">
        <label class="labelName">是否全景图：</label>
        <input type="radio" name="isQJ" value="1" />是
        <input type="radio" name="isQJ" value="0" checked />否
      </div>
      <br />
      <div class="lableFile">
        <label>文件：</label>
        <button
          type="button"
          class="layui-btn layui-btn layui-btn-sm marginLeft10"
          id="lableFile"
        >
          选择文件
        </button>
      </div>
      <br />
      <div class="qjLink" style="display: none">
        <label class="labelName">全景链接：</label>
        <input id="qjLink" type="text" />
      </div>
      <br />
      <div class="form-group rt">
        <button id="lableSubmit"></button>
        <button
          type="button"
          class="layui-btn"
          onclick="EaBIM.lableSaveChange()"
        >
          提交
        </button>
      </div>
      <br />
    </div>
    <!-- 添加参数 -->
    <div class="AddProperty">
      <p>
        <button
          type="button"
          class="layui-btn layui-btn-normal layui-btn-sm marginLeft10"
          onclick="EaBIM.addPropertyGroup()"
        >
          添加分组
        </button>
        <br />
        <br />
      </p>
    </div>
    <el-card
      class="liveBarCodeShow"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="modelId"
    >
      <div style="display: flex; justify-content: center; align-item: center">
        <div :class="addClass" v-show="isShowaddClass">
          <el-select
            filterable
            v-model="value"
            placeholder="请选择"
            @change="typeChange"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div :class="addClass" v-show="isShowaddClass">
          <el-input
            placeholder="请输入名称"
            class="search-input"
            v-model="query"
          ></el-input>
        </div>
        <div :class="addClass" v-show="isShowaddClass">
          <el-button icon="el-icon-search" @click="aa()"></el-button>
        </div>
        <div>
          <el-button :icon="iconClass" @click="isShow2"></el-button>
        </div>
      </div>
      <div :class="addClass" v-show="isShowaddClass">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="mobl04" label="名称">
            <template slot-scope="scope">
              <el-button
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100%;
                "
                @click="viewThisLable(scope.row)"
                :title="scope.row.mobl04"
                >{{
                  scope.row.mobl04.length > 5
                    ? scope.row.mobl04.substr(0, 5) + "..."
                    : scope.row.mobl04
                }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="mobl05" label="地点"></el-table-column>
          <el-table-column prop="mobl06S" label="拍摄时间"></el-table-column>
          <el-table-column prop="mobl04" label="名称">
            <template slot-scope="scope">
              <el-button
                @click="bindLable(scope.row)"
                :type="scope.row.mobl10 == null ? 'primary' : 'warning'"
                >{{ scope.row.mobl10 == null ? "绑定" : "解绑" }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin: 10px 0"
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[100, 50, 10]"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <div id="liveLabel" style="display: none">
      <live-label :jsonData="jsonData"></live-label>
    </div>
    <!-- sjLink -->
    <el-dialog
      :close-on-click-modal="false"
      title="选择关联文档"
      :visible.sync="dialogVisible"
      width="70%"
      top="2%"
    >
      <el-select
        filterable
        v-model="types"
        @change="selectlist"
        placeholder="请选择"
      >
        <el-option label="全部" value=" "></el-option>
        <el-option
          :label="item.Name"
          v-for="(item, index) in labelData"
          :key="index"
          :value="item.lbst03"
        ></el-option>
      </el-select>
      <div class="rygl-table">
        <el-table
          align="center"
          class="margin-20 table"
          :data="userList"
          style="width: 100%"
          ><el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="center" prop="lbst03" label="资源类型">
            <template slot-scope="scope">{{
              scope.row.lbst03 == 1
                ? "照片"
                : scope.row.lbst03 == 2
                ? "全景链接"
                : "视频"
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobl04"
            label="名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mobl05"
            label="地点"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mobl06"
            label="拍摄时间"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="user04"
            label="上传用户"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="mobl14"
            label="上传时间"
          ></el-table-column>
          <el-table-column align="center" label="关联">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="guanlianFile(scope.row)"
                >确认关联</el-button
              >
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="seeLiveModel(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <el-pagination
        style="margin-top: 20px"
        align="center"
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="pagenum2"
        :page-sizes="[100, 50, 10]"
        :page-size="pagesize2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total2"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import liveLabel from "../liveLabel.vue";
import interact from "interactjs";
import {
  GetWorkPlaneTree2,
  GetModelLableList,
  FindWorkPlaneModel,
  GetModelLabelSetList,
  GetModelLableSets,
  UpdateModelLable,
} from "@/setAxios";
export default {
  name: "viewModel",
  components: { liveLabel },
  data() {
    return {
      multipleSelection: [],
      pagenum2: 1,
      pagesize2: 10,
      types: "",
      labelData: null,
      dialogVisible: false,
      isShowaddClass: true,
      jsonData: [],
      query: "",
      iconClass: "el-icon-arrow-left",
      addClass: "animated fadeInLeft back",
      addClass2: "animated fadeInLeft locationModel",
      tableData: [],
      url: "",
      options: {},
      value: 0,
      modelId: "",
      options2: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "图片",
        },
        {
          value: 2,
          label: "全景",
        },
        {
          value: 3,
          label: "视频",
        },
      ],
      isdblclick: true,
      btnColor: "",
      modelSelectIds: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      total2: 0,
      testSshow: true,
      timer: null,
      objs: null,
      total2: 0,
      userList: [],
    };
  },
  methods: {
    bindLable(data) {
      if (data.mobl10 != null) {
        data.mobl09 = null;
        data.mobl10 = null;
        data.mobl11 = null;
        data.mobl12 = null;
        UpdateModelLable(data).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "解绑成功",
            });
            this.aa();
          }
        });
      } else {
        var selSet = EaBIM.view.getSelection(),
          fragId = "";
        if (!selSet.length) {
          this.$message({
            type: "error",
            message: "请选择关联构件",
          });
          return;
        }
        var it = EaBIM.view.model.getData().instanceTree;
        it.enumNodeFragments(
          selSet[0],
          function (id) {
            fragId = id;
          },
          false
        );
        data.mobl10 = selSet[0];
        data.mobl11 = fragId;
        data.mobl12 = JSON.stringify(EaBIM.view.getState());
        UpdateModelLable(data).then((res) => {
          this.$message({
            type: "success",
            message: "绑定成功",
          });
          this.aa();
        });
      }
    },
    guanlianFile(data) {
      var selSet = EaBIM.view.getSelection(),
        fragId = "";
      var it = EaBIM.view.model.getData().instanceTree;
      it.enumNodeFragments(
        selSet[0],
        function (id) {
          fragId = id;
        },
        false
      );
      let params = {
        mobl01: data.mobl01,
        mobl09: EaBIM.modelData.modelId,
        mobl10: selSet[0],
        mobl11: fragId,
        mobl12: JSON.stringify(EaBIM.view.getState()),
      };
      //11
      UpdateModelLable(params).then((res) => {
        this.$message({
          type: "success",
          message: "关联成功",
        });
        this.aa();
        this.dialogVisible = false;
      });
    },
    // 选择列表类别
    selectlist(i) {
      this.sjLink(i);
    },
    sjLink(num) {
      let params = {
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        type: num || "",
        pageIndex: this.pagenum2,
        pageSize: this.pagesize2,
        fillter: true,
      };
      GetModelLabelSetList({ params }).then((res) => {
        this.total2 = res.Data.total;
        this.userList = res.Data.list;
      });
      params = {
        xid: localStorage.getItem("xid"),
      };
      GetModelLableSets({ params }).then((res) => {
        this.labelData = res.Data;
        this.labelData.map((item) => {
          if (item.lbst03 == num) {
            this.types = item.Name;
          }
        });
      });
      this.dialogVisible = true;
    },
    handleSizeChange2(val) {
      this.pagesize2 = val;
      this.sjLink();
    },
    handleCurrentChange2(val) {
      this.pagenum2 = val;
      this.sjLink();
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      this.objs = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.options);
      if (this.objs != null) {
        if (localStorage.treeNid) {
          var currentNode = this.objs.getNodeByParam(
            "ID",
            localStorage.treeNid
          );
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        localStorage.setItem("treeNid", treeNode.ID);
        _this.showModel(treeNode.ID);
      }
    },
    viewThisLable(data) {
      this.tableData.forEach((d) => {
        if ((data || data.mobl01) == d.mobl01) {
          data = d;
        }
      });
      this.jsonData = JSON.stringify(data);
      EaBIM.view.clearSelection();
      EaBIM.view.setViewFromFile();
      if (data.mobl12) {
        var json = data.mobl12;
        var jsonObject = JSON.parse(json.replace(/'/g, '"'));
        EaBIM.view.restoreState(jsonObject);
      }
      var title = `<span style="font-size:18px;padding-right:3px;">${data.mobl04}</span>标签`;
      if (data.lbst03 == 1 && data.mobl07 == 1) {
        title = `<span style="font-size:18px;padding-right:3px;">${data.mobl04}</span>全景图片`;
      } else if (data.lbst03 == 1) {
        title = `<span style="font-size:18px;padding-right:3px;">${data.mobl04}</span>图片`;
      } else if (data.lbst03 == 2) {
        title = `<span style="font-size:18px;padding-right:3px;">${data.mobl04}</span>全景链接`;
      } else {
        title = `<span style="font-size:18px;padding-right:3px;">${data.mobl04}</span>视频`;
      }
      layer.open({
        type: 1, //此处以iframe举例
        title: title,
        shade: 0,
        area: ["800px", "600px"],
        id: data.mobl01,
        maxmin: true,
        content: $("#liveLabel"),
        btn: [],
        cancel: function () {
          if (data.lbst03 == 3) {
            var myVideo = document.getElementById("videoo");
            myVideo.currentTime = 0;
            myVideo.pause();
          }
        },
      });
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    typeChange(data) {
      this.aa();
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    isShow2() {
      let _this = this;
      if (this.isShow == false) {
        this.isShow = true;
        this.isShowaddClass = true;
        this.addClass = "animated fadeInLeft back";
        this.iconClass = "el-icon-arrow-left";
      } else {
        this.isShow = false;
        this.addClass = "animated fadeOutLeft back";
        this.iconClass = "el-icon-arrow-right";
        setTimeout(function () {
          _this.isShowaddClass = false;
        }, 300);
      }
    },
    viewers(data) {
      if (data.type == 1) {
        this.modelId = data.modelId;
        data.enterType = "sjgl";
        this.aa();
      } else {
        this.modelId = "";
      }
      EaBIM.localServerModels(data);
    },

    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init();
      });
    },
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    showModel(value, index) {
      if (value.length) {
        value = value[0];
      }
      let params = {
        id: value,
      };
      FindWorkPlaneModel(params).then((res) => {
        if (res.Data == null) {
          this.$message({
            type: "warning",
            message: "此节点未绑定模型或选择集",
          });
          return false;
        }
        let data = res.Data;
        this.viewers(data);
      });
    },
    aa() {
      let params = {
        xid: localStorage.xid,
        modelId: this.modelId,
        type: this.value,
        searchword: this.query,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      GetModelLableList(params).then((res) => {
        this.tableData = res.Data.list;
        this.total = res.Data.total;
        EaBIM.lableLoad(res.Data.list);
      });
    },
    // fenye
    handleSizeChange(val) {
      this.pageSize = val;
      this.aa();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.aa();
    },
    reLoadLive() {
      if (this.objs != null) {
        if (localStorage.treeNid) {
          var currentNode = this.objs.getNodeByParam(
            "ID",
            localStorage.treeNid
          );
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
    },
  },
  created() {
    this.flushSession();
    this.getData();
    window.labelVM = this;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#gg");

    interact(".Yuan-title").resizable({
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  },
};
</script>
<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");
#drag {
  left: 90%;
  top: 15%;
}
.testS {
  left: 1490px;
  top: 160px;
}
.testS-title {
  top: 180px;
  left: 1500px;
}
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  // overflow: auto;
  height: 100%;
  // position: relative;
}
/deep/ #ViewerModelStructurePanel {
  top: 120px;
}

.body_viewpoint .treeDemo_viewpoint {
  // background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 623px;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
}
.search-input {
  width: 140px;
}
.back {
  // background: #eee;
}
</style>
